import { useContext } from 'react';

import { TournamentServiceContext } from 'context/tournamentContext';

export const useTournamentService = () => useContext(TournamentServiceContext);
